module.exports = {
  addtocart: 'Añadir al carrito',
  productinfo: 'Producto',
  product: 'Producto',
  productname: ' Producto',
  cont: 'Cantidad ',
  myinfo: 'Mis Info',
  sellcount: 'Venta ',
  qtys: '',
  ticket: '',
  minPrice: 'Precio min',
  minutedelivery: 'entrega minuto',
  offer: '',
  discountinformation: 'Información de descuento',
  merchantannouncement: 'Anuncio de comerciante',
  deliveryprice: 'precio de entrega',
  deliverytime: 'tiempo de entrega',
  bulletin: 'boletín',
  pics: 'Imágenes',
  info: 'Información',
  favorite: 'Favorito',
  favorited: 'Favorito',
  rating: 'Clasificación',
  pay: 'Pagar',
  deliveryfee: 'Gastos de envío',
  cart: 'Carrito',
  empty: 'Vacío',
  total: 'Total',
  completeorder: 'Completo',
  orderid: 'OrderID',
  amounts: 'Importes',
  ordersheet: 'Hoja de pedidos',
  backtomain: 'Volver',
  back: 'Volver',
  notsignin: 'No iniciar sesión',
  signin: 'Iniciar sesión',
  signout: 'Cerrar sesión',
  register: 'registrarse',
  username: 'Nombre de usuario',
  password: 'Contraseña',
  captcha: 'Captcha',
  dsid: 'dsid',
  name: 'Nombre',
  phone: 'Teléfono',
  address: 'Dirección',
  zip: 'C.P.',
  city: 'Ciudad',
  province: 'Provincia',
  pending: 'Pendiente',
  received: 'Recibido',
  complete: 'Completo',
  myaddress: 'Mi dirección',
  customerservice: 'Servicio al cliente',
  onlineservice: 'Servicio en línea',
  lessminprice: 'Falta ',
  todelivery: '',
  language: 'Idiomas',
  confirmorder: 'Confirmar pedido',
  paymode: 'Método de pago',
  paymodearray: 'Visa | Efectivo | Para llevar',
  remark: 'Nota',
  sumbitorder: 'Envio orden',
  ordererror: 'Envio orden error | Dirección incompleta! | Por favor login',
  delivery: 'Gastos de envío',
  subtotal: 'Subtotal',
  newuser: 'Nuevo Usuario',
  loginerror: 'Ingrese un nombre de usuario | Ingrese una contraseña | Ingrese un código de verificación | Error de inicio de sesión | Error de registro | Dos contraseñas incorrectas | Nombre de usuario ya existe | Error al modificar datos',
  loginerror0: 'Ingrese un nombre de usuario',
  loginerror1: 'Ingrese una contraseña',
  loginerror2: 'Ingrese un código de verificación',
  loginerror3: 'Error de inicio de sesión',
  loginerror4: 'Error de registro',
  loginerror5: 'Dos contraseñas incorrectas',
  loginerror6: 'Nombre de usuario ya existe',
  loginerror7: 'Error al modificar datos',
  mydescription: 'Mi perfil',
  description: 'Apodo',
  password2: 'Confirmar contraseña(Dejar en blanco si no ha cambiado)',
  newusertips: 'El nombre de usuario ya existe, vuelva a ingresar | Felicitaciones, se puede usar el nombre de usuario que ingresó',
  completemydirecion: 'Abra la función de dirección y complete una dirección válida',
  prompt: 'Aviso'
}



// WEBPACK FOOTER //
// ./src/i18n/es.js